export interface HeadCell {
	id: string;
	label: string;
	rightAlign: boolean;
}

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

export type Order = 'asc' | 'desc';

export function getComparator<Key extends keyof any>(
	order: Order,
	orderBy: Key,
): (
	a: { [key in Key]: number | string },
	b: { [key in Key]: number | string },
) => number {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
	const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

export const sortTableByKey = <T extends object>(
	array: T[],
	key: keyof T,
	order: Order,
	type: 'string' | 'number',
) => {
	if (type === 'string') {
		// Sort strings alphabetically
		return order === 'asc'
			? array.sort((a: T, b: T) =>
					a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0,
			  )
			: array.sort((a: T, b: T) =>
					a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0,
			  );
	} else {
		// Sort by strings with numbers
		return order === 'asc'
			? array.sort((a: unknown, b: unknown) =>
					parseFloat(a[key] as string) < parseFloat(b[key] as string)
						? -1
						: parseFloat(a[key] as string) > parseFloat(b[key] as string)
						? 1
						: 0,
			  )
			: array.sort((a: unknown, b: unknown) =>
					parseFloat(a[key] as string) > parseFloat(b[key] as string)
						? -1
						: parseFloat(a[key] as string) < parseFloat(b[key] as string)
						? 1
						: 0,
			  );
	}
};
